export enum CustomDatabaseValue {
    Other = 'OTHER',
}
